<template>
  <div>
    <v-row class="px-6 mb-4">
      <v-col cols="3">
        <v-text-field
          v-model="searchInputValue"
          prepend-inner-icon="$magnify"
          outlined
          dense
          single-line
          hide-details="auto"
          :placeholder="$t('spedilink.persons.searchPlaceholder')"
          clearable
        />
      </v-col>
    </v-row>

    <v-data-table
      :items="persons"
      :loading="loading"
      :headers="headers"
      hide-default-footer
      :page="dataTableOptions.page"
      :items-per-page="dataTableOptions.itemsPerPage"
      @update:options="updateOptions"
    >
      <template v-slot:[`item.addedBy`]="{ item }">
        <span v-if="item.addedByFirstName || item.addedByLastName">
          {{ item.addedByFirstName }} {{ item.addedByLastName }}
        </span>
        <span v-else>—</span>
        <div class="text-caption grey--text">
          {{ item.createdAt | dateFormat }}
        </div>
      </template>

      <template v-slot:footer v-if="pageCount > 1">
        <v-pagination v-model="dataTableOptions.page" :length="pageCount" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Service from '@/services'

export default {
  name: 'PublicSpedilinkPersonsTable',
  data () {
    return {
      persons: [],
      loading: false,
      pageCount: 1,
      searchInputValue: '',
      searchTimeout: null,
      dataTableOptions: {
        page: 1,
        itemsPerPage: 15
      },
      sortProperties: [],
      headers: [
        { text: this.$t('spedilink.persons.firstName'), value: 'firstName' },
        { text: this.$t('spedilink.persons.lastName'), value: 'lastName' },
        { text: this.$t('spedilink.persons.email'), value: 'email' },
        { text: this.$t('spedilink.persons.phone'), value: 'phone' },
        { text: this.$t('publicSpedilink.persons.addedBy'), value: 'addedBy', sortable: false }
      ]
    }
  },
  async created () {
    await this.loadPersons()
  },
  watch: {
    searchInputValue () {
      this.dataTableOptions.page = 1
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.loadPersons()
      }, 500)
    },
    'dataTableOptions.page' () {
      this.loadPersons()
    }
  },
  methods: {
    async loadPersons () {
      this.loading = true
      try {
        const params = {
          page: this.dataTableOptions.page,
          pageSize: this.dataTableOptions.itemsPerPage
        }
        if (this.searchInputValue) params.search = this.searchInputValue
        if (this.sortProperties.length > 0) {
          params.sortableProperties = JSON.stringify(this.sortProperties)
        }
        const { data } = await Service.get('spedilink/PublicSpediLinkUsers/GetList', params)
        this.persons = data.results
        this.pageCount = Math.ceil(data.count / this.dataTableOptions.itemsPerPage)
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    updateOptions (options) {
      this.sortProperties = options.sortBy.map((element, index) => ({
        propertyName: element,
        priority: index,
        type: options.sortDesc[index] ? 1 : 0
      }))
      this.loadPersons()
    }
  }
}
</script>
